var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RkDate',{staticClass:"mr-10",attrs:{"position":"top","format":"YYYY-MM-DD HH:mm:ss"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})}
var staticRenderFns = []

export { render, staticRenderFns }